import styled from "styled-components";

export const ProfileSidebarWrapper = styled.div`
  display: flex;
  width: 30%;
  position: relative;
  flex-direction: column;
  @media (max-width: 991.98px) {
    width: 100%;
  }
`;

export const ProfileMain = styled.div`
  background: ${(props) => props.theme.body};
  width: 100%;
  box-shadow: 1px 6px 20px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 15px 20px;
  margin: 10px;
  @media (max-width: 767.98px) {
    margin: 0 auto;
  }
  & h4 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 126.2%;
    text-align: center;
    color: ${(props) => props.theme.textColor};
    margin-bottom: 20px;
  }
  & span {
    color: ${(props) => props.theme.textColor};
    font-family: "Inter";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 126.2%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    & button {
      border: none;
      background: transparent;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      & svg {
        & path {
          stroke: ${(props) => props.theme.textColor};
        }
      }
    }
  }
`;

export const ProfileImage = styled.div`
  width: 120px;
  height: 120px;
  margin: 10px auto 20px;
  border-radius: 50%;
  & img {
    border-radius: 50%;
    width: 120px;
    height: 120px;
  }
`;

export const ProfileText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 126.2%;
  text-align: center;
  color: ${(props) => props.theme.textColor};
`;

export const ProfileLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;

  & a {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin: 0 10px;
    position: relative;
    & svg {
      width: 55%;
      height: auto;
      & path {
        fill: ${(props) => props.theme.textColor};
      }
    }
  }
`;

export const ProfileAuthor = styled.div`
  margin-top: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 126.2%;
  color: ${(props) => props.theme.subtitleColor};
  & a {
    color: #0088cc;
  }
`;

export const UserButton = styled.button`
  background: #0088cc;
  border-radius: 25px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 126.2%;
  color: #ffffff;
  border: none;
  min-width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #0088cc;
  transition: 0.2s;
  margin-top: 20px;
  white-space: nowrap;
  &:hover {
    background: transparent;
    color: #0088cc;
    border: 1px solid #0088cc;
    & svg {
      & path {
        stroke: #0088cc;
      }
    }
  }
  & svg {
    margin-right: 5px;
    & path {
      transition: 0.2s;
    }
  }
`;
